import React from "react"
import { Row, Col } from 'antd';
import './style.scss'
const arrs = [
    {time:'08:40 - 09:00',con:"Opening Remarks: Dawn Song"},
    {time:'',con:"Session 1"},
    {time:'09:00 - 09:30',con:"Invited Talk #1: Yisen Wang"},
    {time:'09:30 - 09:45',con:"Contributed Talk #1"},
    {time:'09:45 - 10:15',con:"Invited Talk #2: Nicolas Papernot"},
    {time:'10:15 - 10:30',con:"Coffee Break"},
    {time:'',con:"Session 2"},
    {time:'10:30 - 11:00',con:"Invited Talk #3: Zico Kolter"},
    {time:'11:00 - 11:15',con:"Contributed Talk #2"},
    {time:'11:15 - 11:30',con:"Poster Spotlights #1"},
    {time:'11:30 - 13:00',con:"Lunch"},
    {time:'',con:""},
]
const arrs1 =[
    {time:'',con:'Session 3'}, 
    {time:'13:00 - 13:30',con:'Invited Talk #4: Lujo Bauer'},
    {time:'13:30 - 13:45',con:'Contributed Talk #3'},
    {time:'13:45 - 14:15',con:'Invited Talk #5: Ce Zhang'},
    {time:'14:15 - 15:00',con:'Poster Session/Break'},
    {time:'',con:'Session 4'},
    {time:'15:00 - 15:30',con:"Invited Talk #6: Una-May O'Reilly"},
    {time:'15:30 - 16:00',con:'Invited Talk #7: Ding Zhao'},
    {time:'',con:'Session 5'},
    {time:'16:00 - 16:45',con:'Winners results showoff'},
    {time:'16:45 - 17:00',con:'Awarding session'},
    {time:'17:00 - 17:45',con:"Poster Session (cont'd)"},
]
export default function Schedule() {
    return <div className="page-schedule">
            <div className="schedule-title">Schedule</div>
            <div className="schedule-detail">
                Date: June 19
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 
                Time in PT
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 
                Location: <a href="https://berkeley.zoom.us/j/93687925763?pwd=blZ6dzZCVVRvM1RUdXYxOWUvYUtHZz09">Zoom</a>
            </div>
            <Row className="list-ul">
                <Col xl={12} span={24} className="list-li"> 
                {arrs.map((item, index) => {
                    if(item.time){
                        return <div className="list-two" key={index}>
                            <span>{item.time}</span>
                            <div>{item.con}</div>
                        </div>
                    }else{
                        return <div className="list-one" key={index}>
                            <span></span>
                            <div>{item.con}</div>
                        </div>
                    }
                })}
                </Col>
                <Col xl={12} span={24} className="list-li"> 
                {arrs1.map((item, index) => {
                    if(item.time){
                        return <div className="list-two" key={index}>
                            <span>{item.time}</span>
                            <div>{item.con}</div>
                        </div>
                    }else{
                        return <div className="list-one" key={index}>
                            <span></span>
                            <div>{item.con}</div>
                        </div>
                    }
                })}
                </Col>
            </Row>
        </div>
}

